import React, { Component } from "react";

import { connect } from "react-redux";

import ForcastActualLineGraph from "./Forcast_actual_line_graph.jsx";
import FDTable from "./FD-Table";
import CategoryMiddleware from "../../../store/middleware/categoryMiddleware";
import ForcastReportMiddleware from "../../../store/middleware/forecasrDetailMiddleware";
import Button from "@material-ui/core/Button";
import CustomSelect from "../../../components/common/select/Select";
import BrandsMiddleware from "../../../store/middleware/brandsMiddleware";
import SkusMiddleware from "../../../store/middleware/skusMiddleware";
import RegionsMiddleware from "../../../store/middleware/regionMiddleware";
import { compare } from '../../../prat_screen/gt/validation/sort';

import "../../../assets/style/forcast.style.scss";

import "./inner.scss";
import { Loader } from "../../../components/loader";

const weekNo = [
  "01",
  "02",
  "03",
  "04",
  "05",
  "06",
  "07",
  "08",
  "09",
  10,
  11,
  12,
  13,
  14,
  15,
  16,
  17,
  18,
  19,
  20,
  21,
  22,
  23,
  24,
  25,
  26,
  27,
  28,
  29,
  30,
  31,
  32,
  33,
  34,
  35,
  36,
  37,
  38,
  39,
  40,
  41,
  42,
  43,
  44,
  45,
  46,
  47,
  48,
  49,
  50,
  51,
  52,
];

class ForcastDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedWeeks: [1, 2, 3, 4, 5, 6, 7, 8],
      errorMessage: "",
      weekly: true,
      switch: true,
      seletcWeek: true,
      myTempSkus: [],
      myTempBrands: [],
      myBrands: [],
      mySkus: [],
      selectedCategory: [],
      selectedBrand: [],
      selectedSku: [],
      selectedRegion: [],
      weekFrom: 1,
      weekTo: 52,
      selectedYear: "",
      years: [],
      agreedBaselineForecast: true,
      Promo_EDLP_TPR: false,
      Promo_EDLP_SBB: false,
      customerPromotionSBB: false,
      customerPromotionTPR: false,
      holidaysDIP: false,
      others: false,
      unconstraintDemand: false,
      Promo_REGBON_TPR: false,
      Promo_REGBON_SBB: false,
      isLoadingInitial: true,
      dataValue: [
        { name: 'Weekly', value: true },
        { name: 'Monthly', value: false }
      ],
      graphLegends: [
        {
          label: 'AgreedBaselineForecast',
          legendColor: '#219EBC',
          state: true
        },
        {
          label: 'PromoEDLP TPR',
          legendColor: '#63993D',
          state: false
        },
        {
          label: 'PromoEDLP SBB',
          legendColor: '#B27AA1',
          state: false
        },
        {
          label: 'CustomerPromotionSBB',
          legendColor: '#8A614B',
          state: false
        },
        {
          label: 'CustomerPromotionTPR',
          legendColor: '#0353A4',
          state: false
        },
        {
          label: 'HolidaysDIP',
          legendColor: '#F8BF06',
          state: false
        },
        {
          label: 'Others',
          legendColor: '#C44536',
          state: false
        },
        {
          label: 'UnconstraintDemand',
          legendColor: '#E57D2F',
          state: false
        },
        {
          label: 'PromoREGBON TPR',
          legendColor: '#4B9795',
          state: false
        },
        {
          label: 'PromoREGBON SBB',
          legendColor: '#68BE5D',
          state: false
        }
      ],
      reportType: [
        { label: 'Primary', value: 'Actuals' },
        { label: 'Secondary', value: 'Secondary' },
        { label: 'Baseline', value: 'Baseline' }
      ],
      selectedReportType: 'Secondary',
      selectedHistoryRef1: '06',
      selectedHistoryRef2: 13,
      selectedFutureRef1: '06',
      selectedFutureRef2: 13,
      historyRef1Value: 0,
      historyRef2Value: 0,
      futureRef1Value: 0,
      futureRef2Value: 0,
      getWeek: true,
      maximumWeek: 52
    };
  }

  componentDidMount() {
    let currentYear = new Date().getFullYear();
    let years = [];
    for (var i = 0; i < 5; i++) {
      years.push({ value: currentYear - i })
    }
    this.setState({
      years: years.reverse()
    })
    setTimeout(() => {
      this.props.getCategory();
      this.props.getBrands();
      this.props.getSkus();
      this.props.getRegions();
    }, 1000);
  }

  componentDidUpdate(prevProps, prevState) {

    if (prevProps.category !== this.props.category) {
      this.getDataOnComponentMount();
    }

    if (prevProps.brands !== this.props.brands) {
      this.getBrands();
    }

    if (prevProps.ForcastDetail !== this.props.ForcastDetail) {
      this.getMaximumWeek(this.props.ForcastDetail[this.state.selectedReportType])
    }
  }

  getMaximumWeek = (value) => {
    if (value && this.state.getWeek) {
      let maxWeek = 13;
      for (var i = 0; i < Object.entries(value).length; i++) {
        if (Object.entries(value)[i][1] === 0) {
          maxWeek = i;
          break;
        }
      }
      this.setState({
        maximumWeek: maxWeek,
        getWeek: false
      }, () => {
        this.hanldeHistoryAvgCalculation(this.props.ForcastDetail[this.state.selectedReportType], this.state.selectedHistoryRef1, 'ref1')
        this.hanldeHistoryAvgCalculation(this.props.ForcastDetail[this.state.selectedReportType], this.state.selectedHistoryRef2, 'ref2')

        this.hanldeUnconstraintDemandFutureAvgCalculation(this.props.ForcastDetail['TotalDemand'], this.state.selectedFutureRef1, 'ref1')
        this.hanldeUnconstraintDemandFutureAvgCalculation(this.props.ForcastDetail['TotalDemand'], this.state.selectedFutureRef2, 'ref2')
      })
    }
  }

  getDataOnComponentMount = () => {
    this.setState(
      {
        selectedCategory: [this.props.category[0].guid],
        selectedYear: new Date().getFullYear(),
      },
      () => {
        if (this.props?.brands) {
          this.getBrands();
        }
        this.props.getForecastDetail(
          this.state.selectedCategory,
          this.state.selectedBrand,
          this.state.selectedSku,
          this.state.selectedRegion,
          this.state.selectedYear,
          this.state.weekFrom,
          this.state.weekTo,
          this.state.seletcWeek
        );
        this.setState({ isLoadingInitial: false });
      }
    );
  };

  getBrands = () => {
    try {
      const {
        selectedCategory
      } = this.state;
      const { brands } = this.props;
      let filteredbrands = [];
      if (selectedCategory.length) {
        for (let i = 0; i < selectedCategory.length; i++) {
          filteredbrands.push(
            ...brands.filter((item) => {
              return item.Category === selectedCategory[i];
            })
          );
        }
      }
      this.setState({
        myBrands: filteredbrands,
      },
        () => {
          let selectBrands = [];
          this.state.myBrands.length &&
            this.state.myBrands.forEach(item => selectBrands.push(item.guid));
          this.setState({
            selectedBrand: selectBrands
          });
        });
      this.getSkus();
    } catch (error) { }
  };

  getSkus = () => {
    setTimeout(() => {
      const { selectedBrand } = this.state;
      const { skus } = this.props;
      let filteredSkus = [];
      if (selectedBrand.length) {
        for (let i = 0; i < selectedBrand.length; i++) {
          filteredSkus.push(
            ...skus.filter((item) => {
              return item.Brand === selectedBrand[i];
            })
          );
        }
      }
      this.setState({
        mySkus: filteredSkus,
      });
    }, 4000);
  };

  handleSubmitFN = async (data) => {
    this.setState({
      weekly: data.seletcWeek,
      getWeek: true
    });
    await this.props.getForecastDetail(
      data.selectedCategory,
      data.selectedBrand,
      data.selectedSku,
      data.selectedRegion,
      data.selectedYear,
      data.weekFrom,
      data.weekTo,
      data.seletcWeek
    );
  };

  selectWeekNo(weekNo, index) {
    let { selectedWeeks } = this.state;
    selectedWeeks = [];
    if (weekNo >= 8) {
      for (let i = weekNo; i > weekNo - 8; i--) {
        selectedWeeks.push(i);
      }
      this.setState({ selectedWeeks, errorMessage: "" });
    } else {
      this.setState({
        errorMessage: "selected weeks must be 8 or more then 8",
      });
    }
  }

  handleMonthly = (value) => {
    this.setState({
      weekly: value,
    });
  };


  handleFilteredSkus = () => {
    const { selectedBrand, selectedSku, mySkus } = this.state;
    const { skus } = this.props;
    let filteredSkus = [];
    if (selectedBrand.length) {
      for (let i = 0; i < selectedBrand.length; i++) {
        filteredSkus.push(
          ...skus.filter((item) => {
            return item.Brand === selectedBrand[i];
          })
        );
      }

      let selectedSkuFinal = [];
      mySkus.forEach((element) => {
        if (selectedSku.length !== 0) {
          selectedSku.forEach((e) => {
            if (element.guid === e) {
              selectedSkuFinal.push(e);
              this.setState({
                selectedSku: selectedSkuFinal,
              });
            }
          });
        }
      });

      this.setState({
        mySkus: filteredSkus,
      });
    }
  };

  handleChangeCategory = (selectedValue) => {
    let arr = [];
    if (selectedValue === null || selectedValue.length === 0) {
      this.setState({
        selectedCategory: [],
        myBrands: [],
        selectedBrand: [],
        selectedSku: [],
        mySkus: [],
      });
    } else {
      selectedValue.forEach((element) => {
        arr.push(element.value);
      });

      this.setState({ selectedCategory: arr }, () => {
        this.getBrands();
      });
    }
  };

  handleBrandChange = (selectedValue) => {
    let arr = [];
    if (selectedValue === null || selectedValue.length === 0) {
      this.setState({ selectedBrand: [], selectedSku: [], mySkus: [] });
    } else {
      selectedValue.forEach((element) => {
        arr.push(element.value);
      });
      this.setState({ selectedBrand: arr }, () => {
        this.handleFilteredSkus();
      });
    }
  };

  handleRegion = (selectedValue) => {
    let arr = [];
    if (selectedValue === null) {
      this.setState({ selectedRegion: [] });
    } else {
      selectedValue.forEach((element) => {
        arr.push(element.value);
      });
      this.setState({ selectedRegion: arr });
    }
  };

  handleSkus = (selectedValue) => {
    let arr = [];
    if (selectedValue === null) {
      this.setState({ selectedSku: [] });
    } else {
      selectedValue.forEach((element) => {
        arr.push(element.value);
      });
      this.setState({ selectedSku: arr });
    }
  };

  handleYear = (selectedValue) => {
    if (selectedValue) {
      this.setState({
        selectedYear: selectedValue.value,
      });
    }
  };

  handleCallSubmit = () => {
    const {
      selectedCategory,
      selectedBrand,
      selectedSku,
      selectedRegion,
      weekFrom,
      weekTo,
      selectedYear,
      seletcWeek,
    } = this.state;
    let data = {
      selectedCategory,
      selectedBrand,
      selectedSku,
      selectedRegion,
      weekFrom,
      weekTo,
      selectedYear,
      seletcWeek,
    };

    this.handleSubmitFN(data);
  };

  handleGraphToggle = (indx) => {
    let newArray = [...this.state.graphLegends]

    if (indx === 0) {
      newArray[indx] = { ...newArray[indx], state: !newArray[indx].state }
      this.setState({
        agreedBaselineForecast: !this.state.agreedBaselineForecast,
        graphLegends: newArray
      });
    }
    if (indx === 1) {
      newArray[indx] = { ...newArray[indx], state: !newArray[indx].state }
      this.setState({
        Promo_EDLP_TPR: !this.state.Promo_EDLP_TPR,
        graphLegends: newArray
      });
    }
    if (indx === 2) {
      newArray[indx] = { ...newArray[indx], state: !newArray[indx].state }
      this.setState({
        Promo_EDLP_SBB: !this.state.Promo_EDLP_SBB,
        graphLegends: newArray
      });
    }
    if (indx === 3) {
      newArray[indx] = { ...newArray[indx], state: !newArray[indx].state }
      this.setState({
        customerPromotionSBB: !this.state.customerPromotionSBB,
        graphLegends: newArray
      });
    }
    if (indx === 4) {
      newArray[indx] = { ...newArray[indx], state: !newArray[indx].state }
      this.setState({
        customerPromotionTPR: !this.state.customerPromotionTPR,
        graphLegends: newArray
      });
    }
    if (indx === 5) {
      newArray[indx] = { ...newArray[indx], state: !newArray[indx].state }
      this.setState({
        holidaysDIP: !this.state.holidaysDIP,
        graphLegends: newArray
      });
    }
    if (indx === 6) {
      newArray[indx] = { ...newArray[indx], state: !newArray[indx].state }
      this.setState({
        others: !this.state.others,
        graphLegends: newArray
      });
    }
    if (indx === 7) {
      newArray[indx] = { ...newArray[indx], state: !newArray[indx].state }
      this.setState({
        unconstraintDemand: !this.state.unconstraintDemand,
        graphLegends: newArray
      });
    }
    if (indx === 8) {
      newArray[indx] = { ...newArray[indx], state: !newArray[indx].state }
      this.setState({
        Promo_REGBON_TPR: !this.state.Promo_REGBON_TPR,
        graphLegends: newArray
      });
    }
    if (indx === 9) {
      newArray[indx] = { ...newArray[indx], state: !newArray[indx].state }
      this.setState({
        Promo_REGBON_SBB: !this.state.Promo_REGBON_SBB,
        graphLegends: newArray
      });
    }
    else {

    }
  };

  handleIsWeelky = (selectedValue) => {
    if (selectedValue) {
      this.setState({
        seletcWeek: selectedValue.value,
      });
    }
  };

  handleReportType = (type) => {
    if (this.state.seletcWeek) {
      this.setState({
        selectedReportType: type.value
      })
      this.hanldeHistoryAvgCalculation(this.props.ForcastDetail[type.value], this.state.selectedHistoryRef1, 'ref1')
      this.hanldeHistoryAvgCalculation(this.props.ForcastDetail[type.value], this.state.selectedHistoryRef2, 'ref2')

      if (type.value === 'Baseline') {
        this.hanldeFutureAvgCalculation(this.props.ForcastDetail['Baseline'], this.state.selectedFutureRef1, 'ref1')
        this.hanldeFutureAvgCalculation(this.props.ForcastDetail['Baseline'], this.state.selectedFutureRef2, 'ref2')
      } else {
        this.hanldeUnconstraintDemandFutureAvgCalculation(this.props.ForcastDetail['TotalDemand'], this.state.selectedFutureRef1, 'ref1')
        this.hanldeUnconstraintDemandFutureAvgCalculation(this.props.ForcastDetail['TotalDemand'], this.state.selectedFutureRef2, 'ref2')
      }
    }
  }

  handleHistoryRefSelection = (historyRef, value) => {
    if (this.state.seletcWeek) {
      if (historyRef === 'ref1') {
        this.setState({
          selectedHistoryRef1: value.value
        })
        this.hanldeHistoryAvgCalculation(this.props.ForcastDetail[this.state.selectedReportType], value.value, 'ref1')
      }
      else {
        this.setState({
          selectedHistoryRef2: value.value
        })
        this.hanldeHistoryAvgCalculation(this.props.ForcastDetail[this.state.selectedReportType], value.value, 'ref2')
      }
    }
  }

  handleFutureRefSelection = (futureRef, value) => {
    if (this.state.seletcWeek) {
      if (futureRef === 'ref1') {
        this.setState({
          selectedFutureRef1: value.value
        })
        this.state.selectedReportType === 'Baseline' ?
          this.hanldeFutureAvgCalculation(this.props.ForcastDetail['Baseline'], value.value, 'ref1')
          :
          this.hanldeUnconstraintDemandFutureAvgCalculation(this.props.ForcastDetail['TotalDemand'], value.value, 'ref1')
      }
      else {
        this.setState({
          selectedFutureRef2: value.value
        })
        this.state.selectedReportType === 'Baseline' ?
          this.hanldeFutureAvgCalculation(this.props.ForcastDetail['Baseline'], value.value, 'ref2')
          :
          this.hanldeUnconstraintDemandFutureAvgCalculation(this.props.ForcastDetail['TotalDemand'], value.value, 'ref2')
      }
    }
  }

  hanldeHistoryAvgCalculation = (data, ref, historyRef) => {
    let refFilterStart = this.state.maximumWeek - parseInt(ref);
    let filterArray = [];
    filterArray = Object.values(data).filter((item, ind) => (ind >= (refFilterStart) && ind < this.state.maximumWeek));
    let totalSum = 0;
    totalSum = filterArray.length && filterArray.reduce((total, num) => (parseFloat(total?.toFixed(2)) + parseFloat(num?.toFixed(2))));
    let avg = (totalSum / filterArray.length)?.toFixed(2);
    if (historyRef === 'ref1') {
      this.setState({
        historyRef1Value: isNaN(avg) ? 0 : avg
      })
    }
    else {
      this.setState({
        historyRef2Value: isNaN(avg) ? 0 : avg
      })
    }
  }

  hanldeFutureAvgCalculation = (data, ref, futureRef) => {
    let refFilterEnd = parseInt(ref) + this.state.maximumWeek;
    let filterArray = [];
    filterArray = Object.values(data).filter((item, ind) => (ind >= this.state.maximumWeek && ind < refFilterEnd));
    let totalSum = 0;
    totalSum = filterArray.length && filterArray.reduce((total, num) => (parseFloat(total?.toFixed(2)) + parseFloat(num?.toFixed(2))));
    let avg = (totalSum / filterArray.length)?.toFixed(2);
    if (futureRef === 'ref1') {
      this.setState({
        futureRef1Value: isNaN(avg) ? 0 : avg
      })
    }
    else {
      this.setState({
        futureRef2Value: isNaN(avg) ? 0 : avg
      })
    }
  }

  hanldeUnconstraintDemandFutureAvgCalculation = (data, ref, futureRef) => {
    let refFilterEnd = parseInt(ref) + this.state.maximumWeek;
    let filterArray = Object.values(data).filter((item, ind) => (ind >= this.state.maximumWeek && ind < refFilterEnd));
    let filterUnconstraintDemand = [];
    filterArray && filterArray.forEach(item => filterUnconstraintDemand.push(item.UnconstraintDemand))
    let totalSum = 0;
    totalSum = filterUnconstraintDemand.length && filterUnconstraintDemand.reduce((total, num) => (parseFloat(total?.toFixed(2)) + parseFloat(num?.toFixed(2))));
    let avg = (totalSum / filterUnconstraintDemand.length)?.toFixed(2);
    if (futureRef === 'ref1') {
      this.setState({
        futureRef1Value: isNaN(avg) ? 0 : avg
      })
    }
    else {
      this.setState({
        futureRef2Value: isNaN(avg) ? 0 : avg
      })
    }
  }

  render() {
    const {
      category,
      ForcastDetail,
      regions,
    } = this.props;

    return (
      <div className='page-container'>

        {(this.props.isForecastDetailLoading) || (this.state.isLoadingInitial) || (this.props.ForcastDetail === undefined) ? <Loader flag={true} />

          :

          <>

            <div className="heading-and-download-container">

              <span className='component-heading'>Total Demand Graph</span>

            </div>

            <div className="select-container">

              <div className='filters-container-only'>

                <CustomSelect.MyCustomSelect
                  placeholder={"Category"}
                  allowSelectAll={true}
                  isMulti
                  options={
                    category
                      ? category.sort(compare).map((item) => {
                        return {
                          value: item.guid,
                          label: item.Name,
                        };
                      })
                      : []
                  }
                  onChange={this.handleChangeCategory}
                  value={category
                    .filter((item) => {
                      return this.state.selectedCategory.includes(item.guid);
                    })
                    .map((item) => {
                      return {
                        value: item.guid,
                        label: item.Name,
                      };
                    })}
                />

                <CustomSelect.MyCustomSelect
                  placeholder={"Brands"}
                  allowSelectAll={true}
                  isMulti
                  options={
                    this.state.myBrands
                      ? this.state.myBrands.sort(compare).map((item) => ({
                        value: item.guid,
                        label: item.Name,
                      }))
                      : []
                  }
                  onChange={this.handleBrandChange}
                  value={this.state.myBrands
                    .filter((item) => {
                      return this.state.selectedBrand.includes(item.guid);
                    })
                    .map((item) => {
                      return {
                        value: item.guid,
                        label: item.Name,
                      };
                    })}
                />

                <CustomSelect.MyCustomSelect
                  placeholder={"MSKUs"}
                  allowSelectAll={true}
                  isMulti
                  options={
                    this.state.mySkus
                      ? this.state.mySkus.sort(compare).map((item) => ({
                        value: item.guid,
                        label: item.Description,
                      }))
                      : []
                  }
                  onChange={this.handleSkus}
                  value={this.state.mySkus
                    .filter((item) => {
                      return this.state.selectedSku.includes(item.guid);
                    })
                    .map((item) => {
                      return {
                        value: item.guid,
                        label: item.Description,
                      };
                    })}
                />

                <CustomSelect.MyCustomSelect
                  placeholder={"Region"}
                  allowSelectAll={true}
                  isMulti
                  options={
                    regions
                      ? regions.sort(compare).map((item) => ({
                        value: item.guid,
                        label: item.Name.toUpperCase(),
                      }))
                      : []
                  }
                  onChange={this.handleRegion}
                  value={
                    regions
                      ? regions
                        .filter((item) => {
                          return this.state.selectedRegion.includes(
                            item.guid
                          );
                        })
                        .map((item) => {
                          return {
                            value: item.guid,
                            label: item.Name.toUpperCase(),
                          };
                        })
                      : null
                  }
                />

                <CustomSelect.MySelect
                  placeholder={"Years"}
                  options={this.state.years.map((item) => ({
                    value: item.value,
                    label: item.value,
                  }))}
                  onChange={this.handleYear}
                  value={
                    this.state.years && this.state.years.filter(item => {
                      return item.value === this.state.selectedYear
                    })
                      .map(item => {
                        return {
                          value: item.value,
                          label: item.value
                        };
                      })
                  }
                />

                <CustomSelect.MyCustomSelect
                  // isClearable={true}
                  className='select-box'
                  options={
                    this.state.dataValue.map((item) => ({
                      value: item.value,
                      label: item.name,
                    }))
                  }
                  onChange={this.handleIsWeelky}
                  value={this.state.dataValue
                    .filter(item => {
                      return item.value === this.state.seletcWeek;
                    })
                    .map(item => {
                      return {
                        value: item.value,
                        label: item.name
                      };
                    })}
                />

              </div>

              <Button
                variant="outlined"
                className="submit-btn"
                onClick={() => this.handleCallSubmit()}
              >SUBMIT
            </Button>

            </div>

            <div className="fd-linegraph-data">
              <div className="fa-graph-heading">
                <span
                >
                  <span>Total Demand</span></span>
              </div>
              <ForcastActualLineGraph
                data={ForcastDetail ? ForcastDetail : {}}
                weekly={this.state.weekly ? this.state.weekly : false}
                myAgreedBaselineForecast={this.state.agreedBaselineForecast}
                myPromo_EDLP_TPR={this.state.Promo_EDLP_TPR}
                myPromo_EDLP_SBB={this.state.Promo_EDLP_SBB}
                myCustomerPromotionSBB={this.state.customerPromotionSBB}
                myCustomerPromotionTPR={this.state.customerPromotionTPR}
                myHolidaysDIP={this.state.holidaysDIP}
                myOthers={this.state.others}
                myUnconstraintDemand={this.state.unconstraintDemand}
                myPromo_REGBON_TPR={this.state.Promo_REGBON_TPR}
                myPromo_REGBON_SBB={this.state.Promo_REGBON_SBB}
              />
              <div className='fd-line-chart-legend-container'>
                <span style={{ display: "flex", flexWrap:'wrap' }}>
                  {
                    this.state.graphLegends.map((item, ind) => (
                      <span
                        onClick={() => this.handleGraphToggle(ind)}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          fontSize: "12px",
                          marginRight: "23px",
                          fontWeight: '600'
                        }}
                      >
                        <span
                          style={{
                            width: "16px",
                            height: "8px",
                            borderRadius: '10px',
                            backgroundColor: item.legendColor,
                            marginRight: "5px",
                          }}
                        ></span>
                        <span
                          style={
                            !item.state
                              ? {
                                textDecoration: "line-through",
                                cursor: "pointer",
                              }
                              : { cursor: "pointer" }
                          }
                        >
                          {item.label}
                        </span>
                      </span>
                    ))
                  }
                </span>

              </div>
            </div>

            <div className='avg-container'>
              <div className='avg-section-heading-filter'>
                <span className='avg-section-heading'>History/Future Avg. Values</span>
                <div style={{ display: 'flex', alignItems:'center' }}>
                  <span style={{ marginRight: '16px', marginBottom:'8px' }}>Recent Week: {this.state.maximumWeek}</span>
                  <CustomSelect.MyCustomSelect
                    className='select-box'
                    options={this.state.reportType}
                    onChange={this.handleReportType}
                    value={this.state.reportType
                      .filter(item => {
                        return item.value === this.state.selectedReportType;
                      })
                      .map(item => {
                        return {
                          value: item.value,
                          label: item.label
                        };
                      })}
                  />
                </div>
              </div>

              <div className='avg-section-heading-filter'>
                <div className='avg-box'>
                  <div className='avg-box-heading'>History</div>
                  <div className='avg-box-filter-sec'>
                    <div className='avg-filter-sec'>
                      <div className='label-filter-sec'>
                        <label className='avg-label'>Average of</label>
                        <CustomSelect.MyCustomSelect
                          placeholder='History Ref1'
                          className='select-box'
                          options={weekNo.filter(item => {
                            return item <= this.state.maximumWeek;
                          }).map((item) => ({
                            value: item,
                            label: `${item} Weeks`,
                          }))}
                          onChange={(value) => this.handleHistoryRefSelection('ref1', value)}
                          value={weekNo
                            .filter(item => {
                              return item === this.state.selectedHistoryRef1;
                            })
                            .map(item => {
                              return {
                                value: item,
                                label: `${item} Weeks`
                              };
                            })}
                        />
                      </div>
                      <div className='label-filter-sec'>
                        <label className='avg-label'>Average of</label>
                        <CustomSelect.MyCustomSelect
                          placeholder='History Ref2'
                          className='select-box'
                          options={weekNo.filter(item => {
                            return item <= this.state.maximumWeek;
                          }).map((item) => ({
                            value: item,
                            label: `${item} Weeks`,
                          }))}
                          onChange={(value) => this.handleHistoryRefSelection('ref2', value)}
                          value={weekNo
                            .filter(item => {
                              return item === this.state.selectedHistoryRef2;
                            })
                            .map(item => {
                              return {
                                value: item,
                                label: `${item} Weeks`
                              };
                            })}
                        />
                      </div>
                    </div>
                    <div className='avg-filter-sec'>
                      <div className='label-filter-sec'>
                        <label className='avg-label'>Average</label>
                        <span className='avg-display'>{this.state.historyRef1Value}</span>
                      </div>
                      <div className='label-filter-sec'>
                        <label className='avg-label'>Average</label>
                        <span className='avg-display'>{this.state.historyRef2Value}</span>
                      </div>
                    </div>
                  </div>
                </div>

                <div className='avg-box'>
                  <div className='avg-box-heading'>Future</div>
                  <div className='avg-box-filter-sec'>
                    <div className='avg-filter-sec'>
                      <div className='label-filter-sec'>
                        <label className='avg-label'>Average of</label>
                        <CustomSelect.MyCustomSelect
                          className='select-box'
                          options={weekNo.filter(item => {
                            return item <= (52 - this.state.maximumWeek);
                          }).map((item) => ({
                            value: item,
                            label: `${item} Weeks`,
                          }))}
                          onChange={(value) => this.handleFutureRefSelection('ref1', value)}
                          value={weekNo
                            .filter(item => {
                              return item === this.state.selectedFutureRef1;
                            })
                            .map(item => {
                              return {
                                value: item,
                                label: `${item} Weeks`
                              };
                            })}
                        />
                      </div>
                      <div className='label-filter-sec'>
                        <label className='avg-label'>Average of</label>
                        <CustomSelect.MyCustomSelect
                          className='select-box'
                          options={weekNo.filter(item => {
                            return item <= (52 - this.state.maximumWeek);
                          }).map((item) => ({
                            value: item,
                            label: `${item} Weeks`,
                          }))}
                          onChange={(value) => this.handleFutureRefSelection('ref2', value)}
                          value={weekNo
                            .filter(item => {
                              return item === this.state.selectedFutureRef2;
                            })
                            .map(item => {
                              return {
                                value: item,
                                label: `${item} Weeks`
                              };
                            })}
                        />
                      </div>
                    </div>
                    <div className='avg-filter-sec'>
                      <div className='label-filter-sec'>
                        <label className='avg-label'>Average</label>
                        <span className='avg-display'>{this.state.futureRef1Value}</span>
                      </div>
                      <div className='label-filter-sec'>
                        <label className='avg-label'>Average</label>
                        <span className='avg-display'>{this.state.futureRef2Value}</span>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </div>

            <div style={{ width: "100%" }}>
              <FDTable
                data={ForcastDetail ? ForcastDetail : {}}
                weekNo={weekNo}
                weekly={this.state.weekly ? this.state.weekly : false}
              />
            </div>
          </>
        }
      </div>
    )
  }
}
const mapStateToProps = (state) => {
  return {
    category: state.CategoryReducer.category,
    isLoading: state.CategoryReducer.isLoading,
    ForcastDetail: state.ForecastDetailReducer.ForcastDetail,
    isForecastDetailLoading:
      state.ForecastDetailReducer.isForecastDetailLoading,
    isCategoryLoading: state.CategoryReducer.isCategoryLoading,
    brands: state.BrandsReducer.brands,
    skus: state.SkusReducer.skus,
    regions: state.RegionReducer.regions,
  };
};

const mapDispatchToprops = (dispatch) => {
  return {
    getCategory: () => {
      return dispatch(CategoryMiddleware.getCategory());
    },
    getForecastDetail: (
      selectedCategory,
      selectedBrand,
      selectedSku,
      selectedRegion,
      selectedYear,
      weekFrom,
      weekTo,
      seletcWeek
    ) => {
      return dispatch(
        ForcastReportMiddleware.getForecastDetail(
          selectedCategory,
          selectedBrand,
          selectedSku,
          selectedRegion,
          selectedYear,
          weekFrom,
          weekTo,
          seletcWeek
        )
      );
    },
    getBrands: () => {
      return dispatch(BrandsMiddleware.getBrands());
    },
    getSkus: () => {
      return dispatch(SkusMiddleware.getSkus());
    },
    getRegions: () => {
      return dispatch(RegionsMiddleware.getRegions());
    },
  };
};

export default connect(mapStateToProps, mapDispatchToprops)(ForcastDetails);
